import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ProjectCreateDialog } from '@/features/projects/components/ProjectCreateDialog';

export function ProjectCreatePage() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const close = () => {
    setOpen(false);
    void navigate({ to: '/projects' });
  };

  return <ProjectCreateDialog open={open} onClose={close} />;
}
